const useMaskUtils = () => {
    const unMask = (value?: string) => {
        if(!value) return value;
        return value.replace(/\D/g, '');
    }
    const maskCpf = (value?: string) => {
        if(!value) return value;
        return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    };

    const maskCnpj = (value?: string) => {
        if(!value) return value;
        return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }

    const maskPhone = (value?: string) => {
        if(!value) return value;
        return value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})\d+?$/, '$1');
    };

    return {
        unMask,
        maskCpf,
        maskCnpj,
        maskPhone,
    };
}
export default useMaskUtils;